import React, { useEffect } from 'react';
import { useUser } from '@gadgetinc/react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

const RequireSignedInRole = ({ children, role }) => {
  const navigate = useNavigate();
  const user = useUser(api);

  // Normalize role to always be an array
  const requiredRoles = Array.isArray(role) ? role : [role];

  useEffect(() => {
    // If user is null (unauthenticated), redirect to home
    if (user === null) {
      navigate('/');
      return;
    }

    // If user exists, check if they have any of the required roles
    if (user) {
      const hasRequiredRole = user.roles?.some(userRole => {
        // Handle string roles
        if (typeof userRole === 'string') {
          return requiredRoles.includes(userRole);
        }
        // Handle object roles - check both key and name properties
        const roleKey = userRole?.key;
        const roleName = userRole?.name;
        return requiredRoles.includes(roleKey) || requiredRoles.includes(roleName);
      });

      // If user doesn't have any required role, redirect to home
      if (!hasRequiredRole) {
        console.log('RequireSignedInRole: User does not have required role');
        console.log('User roles:', user.roles);
        console.log('Required roles:', requiredRoles);
        navigate('/');
        return;
      }
    }
  }, [user, navigate, requiredRoles]);

  // If user is null (unauthenticated), don't render anything while redirecting
  if (user === null) {
    return null;
  }

  // If user exists, check if they have any of the required roles
  if (user) {
    const hasRequiredRole = user.roles?.some(userRole => {
      // Handle string roles
      if (typeof userRole === 'string') {
        return requiredRoles.includes(userRole);
      }
      // Handle object roles - check both key and name properties
      const roleKey = userRole?.key;
      const roleName = userRole?.name;
      return requiredRoles.includes(roleKey) || requiredRoles.includes(roleName);
    });

    // If user doesn't have any required role, don't render anything while redirecting
    if (!hasRequiredRole) {
      return null;
    }

    // User has one of the required roles, render children
    return children;
  }

  // Fallback case - don't render anything
  return null;
};

export default RequireSignedInRole;